import { Injectable } from '@angular/core';
import { HttpService } from './../http-service';

import { Observable } from 'rxjs/Rx'
import { Residuo } from '../../domain/residuo';

@Injectable()
export class ResiduoProvider {
  public residuo: Residuo;
  private _url: string = '/vigencias';

  constructor(public http: HttpService) { }
  
  public getById(id:number): Observable <any>{
    return this.http.get(this._url+'/'+id)
              .map(res => {
                return res.json().data;
              });
  }

  public getResiduoAtivoByEventoId(evento_id:number): Observable <any>{
    return this.http.get(this._url+'/searchInEvento/'+evento_id)
              .map(res => {
                return res.json().residuos;
              })
              .catch(res => {
                return res
              });
  }
  

}

  



// WEBPACK FOOTER //
// ./src/providers/reciclagem/residuo.provider.ts